export default __webpack_public_path__ + "static/media/user.c3b244f0.svg";